import { render, staticRenderFns } from "./confirm.component.vue?vue&type=template&id=885a74f4"
import script from "./confirm.component.ts?vue&type=script&lang=ts&external"
export * from "./confirm.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('885a74f4')) {
      api.createRecord('885a74f4', component.options)
    } else {
      api.reload('885a74f4', component.options)
    }
    module.hot.accept("./confirm.component.vue?vue&type=template&id=885a74f4", function () {
      api.rerender('885a74f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Confirm/confirm.component.vue"
export default component.exports